/**
 * When the sidebar shows "My Quizzes": something is open (quizzes or scenario steps), or the
 * user is a Viewer or Editor on Quizzes at any store, so they can always look back at their
 * own results. Quiz managers and admins don't get it for that alone. See
 * docs/archive/QUIZ_SCENARIOS_PLAN.md § 0.2.
 */

import type { PageAccessConfig } from '@/shared/types/permissions.types';
import { isLocationBasedAccess } from '@/shared/types/permissions.types';

export function showMyQuizzesLink(openCount: number, pageAccess: PageAccessConfig | undefined): boolean {
  if (openCount > 0) return true;
  const access = pageAccess?.quizzes;
  return !!access?.enabled && isLocationBasedAccess(access) && Object.keys(access.locations ?? {}).length > 0;
}
